<template>
    <a :href="url" :class="{ disabled }">
        <i class="fas fa-project-diagram"></i> {{resource('JourneyComposer_Overview_JourneyReport_Button')}}
    </a>
</template>

<script>
import resourceMixin from "@core/Util/Mixins/resources";
import api from "@modules/JourneyBuilder/api";

export default {
    name: "NavigateToActionableReportLink",
    mixins: [resourceMixin],
    computed: {
        url(){
            if(this.disabled){
                return '#';
            }
            
            return api.getStatisticsPageUrl(this.journeyId, this.highlightedBrickId);
        }
    },
    props: {
        journeyId: {
            type: String,
            required: false
        },
        highlightedBrickId: {
            type: String,
            required: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    }
}
</script>
